import { lazy } from 'react'

const Home = lazy(() => import(/* webpackChunkName: "Home" */ './Home'))
export default Home
